<template>
  <TabView>
    <TabPanel header="Количество жидкости">
      <div class="formgrid grid">
        <div class="tm-liquid">
          <TabView @tab-change="tabChange">
            <TabPanel header="Архив">
              <div class="tm-liquid-archive">
                <ViewCustomData v-if="tabIndex[0]" entityName="liquid_log" entitySpec="yearmonth" scrollHeight="690px"
                  ref="viewLiquidLogYearmonth" serviceName="BaseService" :columns="PROPERTY_LIQUID_COLUMNS"
                  :toolbarFilters="toolbarFiltersYearmonth" :rows="100" :dictionary="PROPERTY_LIQUID_DICTIONARY"
                  :prepareData="prepareDataPropertyLiquid" :visibleButtons="VISIBLE_BUTTONS">
                  <template #toolbar>
                    <Button label="Экспорт Excel" icon="pi pi-file-excel"
                      @click="prepareExportExcel('viewLiquidLogYearmonth', PROPERTY_LIQUID_COLUMNS, 'Архив')"
                      severity="success" class="ml-1 mr-1 component-filter"></Button>
                  </template>
                </ViewCustomData>
              </div>
            </TabPanel>
            <TabPanel header="Шахматка">
              <ViewCustomData v-if="tabIndex[1]" entityName="liquid_log" entitySpec="cross_yearmonth"
                ref="viewLiquidLogCrossYearmonth" serviceName="BaseService" :columns="columnsPorpertyLiquidCross"
                scrollHeight="720px" :toolbarFilters="toolbarFiltersCrossYearmonth" :paginator="false"
                :dictionary="PROPERTY_LIQUID_DICTIONARY" :prepareData="prepareDataPorpertyLiquidCross"
                :tableAttrList="getStyleLiquidLog()" :visibleButtons="VISIBLE_BUTTONS">
                <template #toolbar>
                  <Button label="Экспорт Excel" icon="pi pi-file-excel"
                    @click="prepareExportExcel('viewLiquidLogCrossYearmonth', columnsPorpertyLiquidCross, 'Шахматка')"
                    severity="success" class="ml-1 mr-1 component-filter"></Button>
                </template>
              </ViewCustomData>
            </TabPanel>
            <TabPanel header="Двухчасовки">
              <ViewCustomData v-if="tabIndex[2]" entityName="liquid_log" entitySpec="hour_cross" scrollHeight="720px"
                ref="viewLiquidLogHourCross" serviceName="BaseService" :columns="[...propertyLiquidHourlyColumns,
                ...columnsPropertyLiquidHourlyPipe]" :toolbarFilters="toolbarFiltersHourly"
                :prepareData="prepareDataPorpertyLiquidHourly" :contextMenu="menuModel"
                @selectedRow="(value) => (hourly.selectionRow = value)" :paginator="false"
                @setOriginalParams="setParamsHorly" :tableAttrList="getStyleLiquidLog()"
                :visibleButtons="VISIBLE_BUTTONS">
                <template #toolbar>
                  <Button label="Экспорт Excel" icon="pi pi-file-excel" @click="prepareExportExcel('viewLiquidLogHourCross', [...propertyLiquidHourlyColumns,
                  ...columnsPropertyLiquidHourlyPipe], 'Двухчасовки')" severity="success"
                    class="ml-1 mr-1 component-filter"></Button>
                </template>
              </ViewCustomData>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </TabPanel>
    <TabPanel header="Все свойства">
      <div class="formgrid grid">
        <div class="property-width">
          <ViewCustomData entityName="property_log" entitySpec="data" serviceName="BaseService"
            ref="viewPropertyLogData" :columns="PROPERTY_LOG_COLUMNS" :toolbarFilters="toolbarFiltersDate"
            :dictionary="PROPERTY_LOG_DICTIONARY" :rows="100" scrollHeight="720px" :visibleButtons="VISIBLE_BUTTONS">
            <template #toolbar>
              <Button label="Экспорт Excel" icon="pi pi-file-excel"
                @click="prepareExportExcel('viewPropertyLogData', PROPERTY_LOG_COLUMNS, 'Все свойства')"
                severity="success" class="ml-1 mr-1 component-filter"></Button>
            </template>
          </ViewCustomData>
        </div>
      </div>
    </TabPanel>
  </TabView>
  <Dialog v-model:visible="hourly.showWriteDialog" :style="{ width: '400px' }" modal>
    <template #header>
      <i class="pi pi-exclamation-circle mr-3" :style="{ 'font-size': '1.5rem', color: 'rgb(204,204,0)' }" />
      <div class="col-10 font-bold text-center" style="font-size: 20px">
        {{ hourlyMode.insert ? 'Задать значение' : 'Удалить значение' }}
      </div>
    </template>

    <div class="formgrid grid align-items-center vertical-container mt-1">
      <div class="col-5"><label>Ус:</label></div>
      <div class="col-7">
        <Dropdown v-model="hourly.selectedPipe" :options="columnsPropertyLiquidHourlyPipe" optionLabel="header"
          optionValue="field" appendTo="body" autofocus style="width: 100%" @change="onChangeHourly">
        </Dropdown>
      </div>
    </div>
    <div class="formgrid grid align-items-center vertical-container mt-2">
      <div class="col-5">
        <label>{{ `${$store.getters.typeFormat(hourly.dateHourly.date, 'date')}:` }}</label>
      </div>
      <div class="col-7">
        <Dropdown v-model="hourly.selectedTime" :options="TIMES" appendTo="body" style="width: 100%"
          @change="onChangeHourly">
        </Dropdown>
      </div>
    </div>
    <div class="formgrid grid align-items-center vertical-container mt-2">
      <div class="col-5">
        <label>Значение:</label>
      </div>
      <div class="col-7">
        <InputText v-if="hourlyMode.insert" v-model="hourly.value" type="number" style="width: 100%" />
        <span v-if="hourlyMode.delete">{{ hourly.value }}</span>
      </div>
    </div>
    <template #footer>
      <Button label="Нет" icon="pi pi-times" class="p-button-text" @click="hourly.showWriteDialog = false" />
      <Button label="Оk" icon="pi pi-check" class="p-button-text" @click="prepareValue" />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, defineEmits, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import { formatString } from '@/core/utils';
import { exportExcel } from '@/core/utils/ExportExcel';
import {
  TIMES,
  PROPERTY_LIQUID_DICTIONARY,
  PROPERTY_LIQUID_COLUMNS,
  PROPERTY_LIQUID_CROSS_DAY_COLUMNS,
  getPropertyLiquidHourlyColumns,
  PROPERTY_LOG_DICTIONARY,
  PROPERTY_LOG_COLUMNS,
  VISIBLE_BUTTONS,
  getToolbarFiltersDate,
  getToolbarFiltersHourly,
  getToolbarFiltersYearmonth,
  getToolbarFiltersCrossYearmonth
} from './constants';

const props = defineProps({ //TODO затычка
  scriptId: { type: null, default: null },
  interception: { type: null, default: null },
});
const emit = defineEmits(['setScript']);//TODO затычка

const store = useStore();
const route = useRoute();
const toast = useToast();

const viewLiquidLogYearmonth = ref(null);
const viewLiquidLogCrossYearmonth = ref(null);
const viewLiquidLogHourCross = ref(null);
const viewPropertyLogData = ref(null);

const tabIndex = reactive({ 0: true });

const facilityDiagram = ref([]);
const facilityFlange = ref([]);

const hourly = reactive({
  selectionRow: null,
  showWriteDialog: false,
  selectedPipe: null,
  dateHourly: {},
  value: null,
  selectedTime: null,
  data: [],
  serviceCorrect: null,
  serviceFlange: null,
  mode: 'insert',
  sources: {},
});

const toolbarFiltersDate = ref(getToolbarFiltersDate(route.params));
const toolbarFiltersHourly = ref(getToolbarFiltersHourly(route.params));
const toolbarFiltersYearmonth = ref(getToolbarFiltersYearmonth(route.params));
const toolbarFiltersCrossYearmonth = ref(getToolbarFiltersCrossYearmonth(route.params));
const propertyLiquidHourlyColumns = ref(getPropertyLiquidHourlyColumns(route.params));

const facilityFlangeService = ref(null);
const facilityDiagramService = ref(null);

const hourlyMode = computed(() => ({
  insert: hourly.mode === 'insert',
  delete: hourly.mode === 'delete',
}));

const columnsPorpertyLiquidCross = computed(() => {
  const result = [];
  const flanges = {};

  for (let index = 0; index < facilityDiagram.value.length; index++) {
    if (facilityDiagram.value[index].date_end) continue;
    const facility = store.getters.facility.find(
      (item) => item.facility_id === facilityDiagram.value[index].child_facility_id
    );
    if (flanges[facilityDiagram.value[index].parent_flange_no]) {
      result[flanges[facilityDiagram.value[index].parent_flange_no] - 1].header =
        `${result[flanges[facilityDiagram.value[index].parent_flange_no] - 1].header} | ${facility.facility_name}`;
    } else {
      result.push({
        header:
          'Ус-' + facilityDiagram.value[index].parent_flange_no +
          (facility?.facility_name ? ' ' + facility.facility_name : ''),
        field: 'flange_no_' + facilityDiagram.value[index].parent_flange_no,
        bodyStyle: 'text-align: right;',
        facilityId: facilityDiagram.value[index].child_facility_id,
        flangeNo: facilityDiagram.value[index].parent_flange_no,
      });
      flanges[facilityDiagram.value[index].parent_flange_no] = result.length;
    }
  }

  if (!result.length && facilityFlange.value.length) {
    for (let index = 0; index < facilityFlange.value.length; index++) {
      result.push({
        header: 'Ус-' + facilityFlange.value[index].flange_no,
        field: 'flange_no_' + facilityFlange.value[index].flange_no,
        bodyStyle: 'text-align: right;',
        facilityId: facilityFlange.value[index].facility_id,
        flangeNo: facilityFlange.value[index].flange_no,
      });
    }
  } else if (result.length < facilityFlange.value.length) {
    for (let index = 0; index < facilityFlange.value.length; index++) {
      if (!flanges[facilityFlange.value[index].flange_no]) {
        result.push({
          header: 'Ус-' + facilityFlange.value[index].flange_no,
          field: 'flange_no_' + facilityFlange.value[index].flange_no,
          bodyStyle: 'text-align: right;',
          facilityId: facilityFlange.value[index].facility_id,
          flangeNo: facilityFlange.value[index].flange_no,
        });
        flanges[facilityFlange.value[index].flange_no] = result.length;
      }
    }
  }

  return [...PROPERTY_LIQUID_CROSS_DAY_COLUMNS, ...result];
});

const columnsPropertyLiquidHourlyPipe = computed(() => {
  const result = [];
  const flanges = {};
  const isGMS = (route.params?.facility_type_id == 6005);
  for (let index = 0; index < facilityDiagram.value.length; index++) {
    if (facilityDiagram.value[index].date_end) continue;
    const facility = store.getters.facility.find(
      (item) => item.facility_id === facilityDiagram.value[index].child_facility_id
    );
    if (flanges[facilityDiagram.value[index].parent_flange_no]) {
      result[flanges[facilityDiagram.value[index].parent_flange_no] - 1].header =
        `${result[flanges[facilityDiagram.value[index].parent_flange_no] - 1].header} | ${facility.facility_name}`;
    } else {
      result.push({
        header:
          'Ус-' + facilityDiagram.value[index].parent_flange_no +
          (facility?.facility_name ? ' ' + facility.facility_name : ''),
        dataType: 'image-text',
        imageField: 'image_no_' + facilityDiagram.value[index].parent_flange_no,
        field: 'flange_no_' + facilityDiagram.value[index].parent_flange_no,
        bodyStyle: 'text-align: right;',
        facilityId: facilityDiagram.value[index].child_facility_id,
        flangeNo: facilityDiagram.value[index].parent_flange_no,
        summary: isGMS ? { type: 'avg' } : { type: 'sum' },
      });
      flanges[facilityDiagram.value[index].parent_flange_no] = result.length;
    }
  }
  if (!result.length && facilityFlange.value.length) {
    for (let index = 0; index < facilityFlange.value.length; index++) {
      result.push({
        header: 'Ус-' + facilityFlange.value[index].flange_no,
        dataType: 'image-text',
        imageField: 'image_no_' + facilityFlange.value[index].flange_no,
        field: 'flange_no_' + facilityFlange.value[index].flange_no,
        bodyStyle: 'text-align: right;',
        facilityId: facilityFlange.value[index].facility_id,
        flangeNo: facilityFlange.value[index].flange_no,
        summary: { type: 'sum' },
      });
    }
  } else if (result.length < facilityFlange.value.length) {
    for (let index = 0; index < facilityFlange.value.length; index++) {
      if (!flanges[facilityFlange.value[index].flange_no]) {
        result.push({
          header: 'Ус-' + facilityFlange.value[index].flange_no,
          dataType: 'image-text',
          imageField: 'image_no_' + facilityFlange.value[index].flange_no,
          field: 'flange_no_' + facilityFlange.value[index].flange_no,
          bodyStyle: 'text-align: right;',
          facilityId: facilityFlange.value[index].facility_id,
          flangeNo: facilityFlange.value[index].flange_no,
          summary: { type: 'sum' },
        });
        flanges[facilityFlange.value[index].flange_no] = result.length;
      }
    }
  }

  return result;
});

const menuModel = computed(() => [
  {
    label: 'Редактировать',
    icon: 'pi pi-pencil',
    command: () => {
      if (store.getters.info.isAdmin || store.getters.info.isControl) {
        hourly.showWriteDialog = true;
        clearHourly();
        hourly.mode = 'insert';
      }
    },
  },
  {
    label: 'Удалить корректировку',
    icon: 'pi pi-trash',
    command: () => {
      if (store.getters.info.isAdmin || store.getters.info.isControl) {
        hourly.showWriteDialog = true;
        clearHourly();
        hourly.mode = 'delete';
      }
    },
  },
]);

const tabChange = (e) => {
  tabIndex[e.index] = true;
};

const writeValue = (data) => {
  if (!hourly.selectedTime || !hourly.selectedPipe || hourly.value === null) return;
  const pipe = columnsPropertyLiquidHourlyPipe.value.find(
    (item) => item.field === hourly.selectedPipe
  );
  const flange = data.find((item) => item.flange_no === pipe.flangeNo);
  const date = new Date(hourly.dateHourly.date.getTime());
  date.setHours(Number(hourly.selectedTime.split(':')[0]));
  date.setMinutes(0);
  date.setSeconds(0);
  const sqlDate = store.getters.formatSqlDateTime(date, true);

  hourly.serviceCorrect
    .insertData({
      flange_id: flange.flange_id,
      accum_outvalue: Number(hourly.value),
      date: sqlDate,
    })
    .then(() => {
      viewLiquidLogHourCross.value?.updateData();
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['TTMPropertyLogForm', 'writeValue'],
      });
    })
    .finally(() => (hourly.showWriteDialog = false));
};

const deleteValue = (data) => {
  if (!hourly.selectedTime || !hourly.selectedPipe || hourly.value === null) return;
  const pipe = columnsPropertyLiquidHourlyPipe.value.find(
    (item) => item.field === hourly.selectedPipe
  );
  const flange = data.find((item) => item.flange_no === pipe.flangeNo);
  const date = new Date(hourly.dateHourly.date.getTime());
  date.setHours(Number(hourly.selectedTime.split(':')[0]));
  date.setMinutes(0);
  date.setSeconds(0);
  const sqlDate = store.getters.formatSqlDateTime(date, true);

  if (!hourly.selectionRow?.sources?.includes(formatString('flange_no_{0}', pipe.flangeNo))) {
    toast.add({
      severity: 'info',
      summary: 'Действие не выполнено',
      detail: 'Корректирующее значение не найдено. Возможно, оно уже было удалено или никогда не создавалось.',
      life: 4000,
    });
  }

  hourly.serviceCorrect
    .deleteData({
      flange_id: flange.flange_id,
      date: sqlDate,
    })
    .then(() => {
      viewLiquidLogHourCross.value?.updateData();
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['TTMPropertyLogForm', 'deleteValue'],
      });
    })
    .finally(() => (hourly.showWriteDialog = false));
};

const prepareValue = () => {
  if (!hourly.serviceCorrect || !hourly.serviceFlange) {
    hourly.serviceCorrect = store.getters.nameToService(
      'BaseService',
      null,
      null,
      'property_log_correct'
    );
    hourly.serviceFlange = store.getters.nameToService(
      'BaseService',
      null,
      null,
      'facility_flange',
      'data'
    );
  }

  hourly.serviceFlange
    .getData({ facility_id: route.params.facility_id }, true)
    .then((data) => {
      if (hourlyMode.value.insert) {
        writeValue(data);
      } else {
        deleteValue(data);
      }
    })
    .catch(() => {
      store.commit('SET_ERROR', {
        er: 'Не удалось загрузить данные фланцев для данного объекта. Проверьте подключение к серверу.',
        source: ['TTMPropertyLogForm', 'prepareValue'],
      });
    });
};

const onChangeHourly = () => {
  if (hourly.selectedTime && hourly.selectedPipe) {
    const pipe = columnsPropertyLiquidHourlyPipe.value.find(
      (item) => item.field === hourly.selectedPipe
    );
    const value = hourly.data.find((item) => item.hour === hourly.selectedTime);
    if (value) {
      hourly.value = value[pipe.field];
    }
  }
};

const prepareExportExcel = (refName, columns, fileName) => {
  let data = [];
  if (refName === 'viewLiquidLogYearmonth') data = viewLiquidLogYearmonth.value?.data || [];
  else if (refName === 'viewLiquidLogCrossYearmonth') data = viewLiquidLogCrossYearmonth.value?.data || [];
  else if (refName === 'viewLiquidLogHourCross') data = viewLiquidLogHourCross.value?.data || [];
  else if (refName === 'viewPropertyLogData') data = viewPropertyLogData.value?.data || [];

  const dateColumns = columns.filter(item =>
    item.dataType ? (item.dataType.includes('time') || item.dataType.includes('date')) : false
  );
  const result = data.map((item) => {
    const dateData = {};
    dateColumns.forEach((col) => {
      dateData[col.field] = store.getters.typeFormat(item[col.field], col.dataType);
    });
    return { ...item, ...dateData };
  });

  exportExcel({
    fileName: `${fileName}.xlsx`,
    tableData: result,
    tableColumns: columns,
  });
};

const setParamsHorly = (param) => {
  hourly.dateHourly = param;
};

const getStyleLiquidLog = () => {
  const length = (facilityDiagram.value.length ? facilityDiagram.value.length : facilityFlange.value.length) + 1;
  const style = { width: '110px' };
  if (length > 0 && length <= 3) style.width = `${length * 105}px`;
  if (length > 3 && length <= 11) style.width = `${length * 95}px`;
  if (length > 11) style.width = `${length * 85}px`;
  return { style };
};

const prepareDataPorpertyLiquidHourly = (data) => {
  const result = [];
  const timesIds = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  for (let h = 0; h < timesIds.length; h++) {
    result.push({ sources: [] });
    const meas = data.filter((item) => item.property_log_hour === timesIds[h]);
    if (meas.length) {
      result[h].hour = `${('0' + meas[0].property_log_hour_name).slice(-5)}`;
    } else {
      result[h].hour = `${('0' + timesIds[h]).slice(-2)}:00`;
    }
    for (let index = 0; index < meas.length; index++) {
      const field = 'flange_no_' + meas[index].flange_no;
      if (result[h][field] === undefined) {
        result[h][field] = meas[index].liquid_outvalue;
      }
      if (meas[index].property_log_source_id === 3) { //TODO: ручная корректировка       
        result[h][field] = meas[index].liquid_outvalue;
        result[h].sources.push(field);
        result[h]['image_no_' + meas[index].flange_no] = 45;
      }
    }
  }
  hourly.data = result;
  return hourly.data;
};

const loadingFlange = () => {
  facilityFlangeService.value
    .getData({ facility_id: route.params.facility_id })
    .then((data) => {
      facilityFlange.value = data.filter(item => item.flange_no !== 0 && item.flange_actual);
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['TTMPropertyLogForm', 'loadingFlange'],
      });
    });

  facilityDiagramService.value
    .getData({ parent_facility_id: route.params.facility_id })
    .then((data) => {
      facilityDiagram.value = data;
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['TTMPropertyLogForm', 'loadingFlange'],
      });
    });
};

const roundToTwo = (num) => {
  return num !== null ? Math.round(num * 100) / 100 : null;
};

const clearHourly = () => {
  hourly.selectedTime = hourly.selectionRow?.hour || null;
  hourly.selectedPipe = null;
  hourly.value = null;
};

const prepareDataPropertyLiquid = (data) => {
  return data.map((item) => ({
    ...item,
    property_log_date: item.property_log_date ? new Date(item.property_log_date) : null,
    property_log_date_time: item.property_log_date ? new Date(item.property_log_date) : null,
    liquid_outvalue: roundToTwo(item.liquid_outvalue),
    property_outvalue: roundToTwo(item.property_outvalue),
    property_value: roundToTwo(item.property_value),
    property_value_last: roundToTwo(item.property_value_last),
    q_liq: roundToTwo(item.q_liq),
  }));
};

const prepareDataPorpertyLiquidCross = (data) => {
  return data.map((item) => ({
    facility_id: item.facility_id,
    flange_no_1: roundToTwo(item.flange_no_1),
    flange_no_2: roundToTwo(item.flange_no_2),
    flange_no_3: roundToTwo(item.flange_no_3),
    flange_no_4: roundToTwo(item.flange_no_4),
    flange_no_5: roundToTwo(item.flange_no_5),
    flange_no_6: roundToTwo(item.flange_no_6),
    flange_no_7: roundToTwo(item.flange_no_7),
    flange_no_8: roundToTwo(item.flange_no_8),
    flange_no_9: roundToTwo(item.flange_no_9),
    flange_no_10: roundToTwo(item.flange_no_10),
    flange_no_11: roundToTwo(item.flange_no_11),
    flange_no_12: roundToTwo(item.flange_no_12),
    flange_no_13: roundToTwo(item.flange_no_13),
    flange_no_14: roundToTwo(item.flange_no_14),
    flange_no_15: roundToTwo(item.flange_no_15),
    flange_no_16: roundToTwo(item.flange_no_16),
    flange_no_17: roundToTwo(item.flange_no_17),
    flange_no_18: roundToTwo(item.flange_no_18),
    flange_no_19: roundToTwo(item.flange_no_19),
    flange_no_20: roundToTwo(item.flange_no_20),
    property_log_day: item.property_log_day,
  }));
};

onMounted(() => {
  facilityFlangeService.value = store.getters.nameToService(
    'BaseService',
    null,
    null,
    'facility_flange',
    'data'
  );
  facilityDiagramService.value = store.getters.nameToService(
    'BaseService',
    null,
    null,
    'facility_diagram',
    'data'
  );
  loadingFlange();
});

</script>

<style scoped lang="scss">
.tm-liquid {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 80%;

  .tm-liquid-archive {
    width: 90%;
  }
}

.property-width {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 90.33%;
}

.component-form {
  margin-top: 0.2rem;
}

@media screen and (max-width: 1200px) {
  .tm-liquid {
    width: 100%;
  }

  .property-width {
    width: 100%;
  }
}

@media screen and (max-width: 960px) {
  .liquid-width {
    width: 100%;
  }

  .property-width {
    width: 100%;
  }
}
</style>